import { createContext, useEffect, useState } from "react";

export const ThemeContext = createContext({
    theme: null,
});

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(
    localStorage.getItem("theme") || "dark"
  );

  const toggleTheme = () => {
   if (theme === "dark") {
    document.documentElement.setAttribute("data-bs-theme", "light");
    setTheme("light");
  } else {
    document.documentElement.removeAttribute("data-bs-theme" ,'dark');
    setTheme("dark");
  }
}
    
useEffect(() => {
    localStorage.setItem("theme", theme);
  }, [theme]);

  return (

    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
